"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getRestClient = void 0;
var rocketchat_rest_client_1 = __importDefault(require("@reaction-club/rocketchat-rest-client"));
var invariant_1 = __importDefault(require("invariant"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var actions_1 = __importDefault(require("../actions"));
var storeHelpers_1 = __importDefault(require("../vendors/storeHelpers"));
var rcClient;
function getRestClient() {
    return rcClient;
}
exports.getRestClient = getRestClient;
var roomsUpdateLocked = false;
var cache = {};
exports["default"] = {
    initRestClient: function (_a) {
        var _this = this;
        var userId = _a.userId, token = _a.token, url = _a.url;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                rcClient = new rocketchat_rest_client_1["default"]({ url: url });
                rcClient.setCredentials({ userId: userId, authToken: token });
                this.rcClient = rcClient;
                // dispatch(this.getMyself())
                dispatch(actions_1["default"].runCleaner());
                return [2 /*return*/];
            });
        }); };
    },
    initStore: function () {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var date, updatedSince, subs, _a, ims, _b, groups, subsRooms, existingSubsRooms, roomsToFetch;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        date = Date.now();
                        updatedSince = moment_1["default"]()
                            .add(-2, 'month')
                            .toISOString();
                        return [4 /*yield*/, rcClient.methods.subscriptions.get({ updatedSince: updatedSince })
                            // dispatch(this.getRooms())
                            // const { groups } = await rcClient.methods.groups.list({ sort: { _updatedAt: -1 } })
                        ];
                    case 1:
                        subs = _c.sent();
                        return [4 /*yield*/, rcClient.methods.im.list({ sort: { _updatedAt: -1 } })];
                    case 2:
                        _a = (_c.sent()).ims, ims = _a === void 0 ? [] : _a;
                        return [4 /*yield*/, rcClient.methods.groups.list({ sort: { _updatedAt: -1 } })];
                    case 3:
                        _b = (_c.sent()).groups, groups = _b === void 0 ? [] : _b;
                        dispatch(actions_1["default"].addRoom(__spreadArrays(ims, groups)));
                        dispatch(actions_1["default"].setRoomDirectOffset(ims.length));
                        dispatch(actions_1["default"].setRoomGroupOffset(groups.length));
                        dispatch(actions_1["default"].setChatUpdateTime(date));
                        subsRooms = lodash_1["default"].filter(subs.update, function (room) { return room.unread > 0; });
                        existingSubsRooms = subsRooms.filter(function (item) { return lodash_1["default"].find(ims, { _id: item.rid }) || lodash_1["default"].find(groups, { _id: item.rid }); });
                        dispatch(actions_1["default"].setUnread(lodash_1["default"].map(existingSubsRooms, function (item) { return ({ roomId: item.rid, unread: item.unread }); })));
                        roomsToFetch = lodash_1["default"].filter(subsRooms, function (item) { return !lodash_1["default"].find(existingSubsRooms, { rid: item.rid }); });
                        roomsToFetch = roomsToFetch.slice(0, 50);
                        return [4 /*yield*/, Promise.all(lodash_1["default"].map(roomsToFetch, function (item) { return dispatch(_this.getRoom(item.rid, { isForce: true, fetchUnReads: false })); }))];
                    case 4:
                        _c.sent();
                        dispatch(actions_1["default"].setUnread(lodash_1["default"].map(roomsToFetch, function (item) { return ({ roomId: item.rid, unread: item.unread }); })));
                        return [2 /*return*/];
                }
            });
        }); };
    },
    getMyself: function (chat_user_id) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, rcClient.methods.users.info({ userId: chat_user_id })];
                    case 1:
                        user = (_a.sent()).user;
                        dispatch(actions_1["default"].setMyself(user));
                        return [2 /*return*/];
                }
            });
        }); };
    },
    // getDirectRooms(options = {}): DispatcherChatResponse {
    //   return async dispatch => {
    //     const sort = { updatedAt: -1 }
    //
    //     const result = await rcClient.methods.im.list({ sort, ...options })
    //     const rooms = result.ims || []
    //
    //     for (let i = 0; i < rooms.length; i++) {
    //       const room = rooms[i]
    //       dispatch(this.addDirectRoom(room))
    //     }
    //
    //     const cursorPosition = result.count + result.offset
    //     // console.log('getDirectRooms', cursorPosition, result)
    //     if (cursorPosition < result.total) {
    //       await dispatch(this.getDirectRooms({ offset: cursorPosition }))
    //     }
    //   }
    // },
    //
    // getGroups(options = {}): DispatcherChatResponse {
    //   return async dispatch => {
    //     const sort = { updatedAt: -1 }
    //     const result = await rcClient.methods.groups.list({ sort, ...options })
    //     const { groups = [] } = result
    //     for (let i = 0; i < groups.length; i++) {
    //       const room = groups[i]
    //       dispatch(this.addPrivateRoom(room))
    //     }
    //
    //     const cursorPosition = result.count + result.offset
    //     if (cursorPosition < result.total) {
    //       await dispatch(this.getGroups({ offset: cursorPosition }))
    //     }
    //   }
    // },
    checkForUpdates: function () {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var chat, fetchDate, updatedSince, _a, update, remove, itemsFiltered, itemsSorted, deletedIds, CHUNK_LENGTH, i, itemsChunk, itemsUnread, intermediateDate, e_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // return await dispatch(this.initStore()) // tmp
                        if (roomsUpdateLocked)
                            return [2 /*return*/, null];
                        chat = getState().chat;
                        fetchDate = Date.now();
                        roomsUpdateLocked = true; // ignore another requests
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 10, , 11]);
                        if (!!chat.chatUpdateDate) return [3 /*break*/, 3];
                        return [4 /*yield*/, dispatch(this.initStore())];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 3:
                        updatedSince = moment_1["default"](chat.chatUpdateDate).toISOString();
                        return [4 /*yield*/, rcClient.methods.subscriptions.get({ updatedSince: updatedSince })];
                    case 4:
                        _a = _b.sent(), update = _a.update, remove = _a.remove;
                        itemsFiltered = lodash_1["default"].filter(update || [], function (_a) {
                            var t = _a.t;
                            return t !== 'c';
                        }) // skip all channels
                        ;
                        itemsSorted = lodash_1["default"].sortBy(itemsFiltered, function (item) { return item._updatedAt; });
                        deletedIds = lodash_1["default"].map(remove, function (item) { return item._id; });
                        if (!lodash_1["default"].isEmpty(deletedIds))
                            dispatch(actions_1["default"].deleteRoom(deletedIds));
                        CHUNK_LENGTH = 30;
                        i = 0;
                        _b.label = 5;
                    case 5:
                        if (!(i < itemsSorted.length)) return [3 /*break*/, 8];
                        itemsChunk = itemsSorted.slice(i, i + CHUNK_LENGTH);
                        // todo we can add optimisation. We can fetch rooms and set it into store by one action
                        return [4 /*yield*/, Promise.all(itemsChunk.map(function (_a) {
                                var rid = _a.rid;
                                return dispatch(_this.getRoom(rid, { isForce: true, fetchUnReads: false }));
                            }))];
                    case 6:
                        // todo we can add optimisation. We can fetch rooms and set it into store by one action
                        _b.sent();
                        itemsUnread = lodash_1["default"].map(itemsChunk, function (item) { return ({ roomId: item.rid, unread: item.unread }); });
                        dispatch(actions_1["default"].setUnread(itemsUnread));
                        intermediateDate = moment_1["default"](itemsChunk[itemsChunk.length - 1]._updatedAt).valueOf();
                        dispatch(actions_1["default"].setChatUpdateTime(intermediateDate));
                        _b.label = 7;
                    case 7:
                        i += CHUNK_LENGTH;
                        return [3 /*break*/, 5];
                    case 8:
                        dispatch(actions_1["default"].setChatUpdateTime(fetchDate));
                        _b.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        e_1 = _b.sent();
                        console.error('chat#checkForUpdates', e_1);
                        return [3 /*break*/, 11];
                    case 11:
                        roomsUpdateLocked = false;
                        return [2 /*return*/];
                }
            });
        }); };
    },
    getRoomMembers: function (roomId) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var _a, members, count, total;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, rcClient.methods.groups.members({ roomId: roomId })];
                    case 1:
                        _a = _b.sent(), members = _a.members, count = _a.count, total = _a.total;
                        if (count !== total)
                            console.error('getRoomMembers can`t receive all members');
                        dispatch(actions_1["default"].setRoomMembers(roomId, members));
                        return [2 /*return*/];
                }
            });
        }); };
    },
    // rocket chat v0.72+
    getRoom: function (roomId, options) {
        if (options === void 0) { options = {}; }
        var _a = options.isForce, isForce = _a === void 0 ? false : _a;
        return isForce ? this.getRoomForce(roomId, options) : this.getRoomLazy(roomId, options);
    },
    getRoomForce: function (roomId, options) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var room, isDirect;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!roomId)
                            return [2 /*return*/, console.error('roomId is required for getRoomForce')];
                        return [4 /*yield*/, rcClient.methods.rooms.info({ roomId: roomId })];
                    case 1:
                        room = (_a.sent()).room;
                        isDirect = room.t === 'd';
                        return [2 /*return*/, isDirect ? dispatch(this.addDirectRoom(room, options)) : dispatch(this.addPrivateRoom(room, options))];
                }
            });
        }); };
    },
    // rocket chat v0.72+
    getRoomLazy: function (roomId, options) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var room;
            return __generator(this, function (_a) {
                room = getState().chat.rooms[roomId];
                if (storeHelpers_1["default"].shouldUpdate(room, storeHelpers_1["default"].TTL.TEN_HOURS))
                    return [2 /*return*/, dispatch(this.getRoomForce(roomId, options))];
                return [2 /*return*/];
            });
        }); };
    },
    addDirectRoom: function (room, options) {
        var _this = this;
        var _a = (options || {}).fetchUnReads, fetchUnReads = _a === void 0 ? true : _a;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var chat, stateRoom, directRoomId, userId;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        chat = getState().chat;
                        stateRoom = chat.rooms[room._id];
                        directRoomId = room._id;
                        userId = directRoomId.replace(((_a = chat.me) === null || _a === void 0 ? void 0 : _a._id) || '', '');
                        if (!userId)
                            return [2 /*return*/, null]; // same user
                        return [4 /*yield*/, dispatch(this.getUser({ userId: userId }, { isForce: false }))];
                    case 1:
                        _b.sent();
                        if (stateRoom && stateRoom.updatedAt === room._updatedAt)
                            return [2 /*return*/, null];
                        dispatch(actions_1["default"].addRoom(room));
                        if (!fetchUnReads) return [3 /*break*/, 3];
                        return [4 /*yield*/, dispatch(this.getUnread(directRoomId))];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    },
    addPrivateRoom: function (room, options) {
        var _this = this;
        var _a = (options || {}).fetchUnReads, fetchUnReads = _a === void 0 ? true : _a;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var chat, stateRoom;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        chat = getState().chat;
                        stateRoom = chat.rooms[room._id];
                        if (stateRoom && stateRoom.updatedAt === room._updatedAt)
                            return [2 /*return*/, null];
                        dispatch(actions_1["default"].addRoom(room));
                        if (!fetchUnReads) return [3 /*break*/, 2];
                        return [4 /*yield*/, dispatch(this.getGroupUnread(room._id))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
    },
    // username called from system messages
    getUser: function (payload, options) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var chat, userId, hash, isForce, e_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        chat = getState().chat;
                        userId = payload.userId;
                        if (userId && userId.length > 17) {
                            payload.userId = userId.replace(((_a = chat.me) === null || _a === void 0 ? void 0 : _a._id) || '', '');
                        }
                        hash = "getUser() : " + JSON.stringify(payload);
                        if (cache[hash]) {
                            return [2 /*return*/, null];
                        }
                        cache[hash] = true;
                        isForce = (options || {}).isForce;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        if (!isForce) return [3 /*break*/, 3];
                        return [4 /*yield*/, dispatch(this.getUserForce(payload))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, dispatch(this.getUserLazy(payload))];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_2 = _b.sent();
                        console.warn('Fetching error: ', e_2);
                        return [3 /*break*/, 7];
                    case 7:
                        delete cache[hash];
                        return [2 /*return*/];
                }
            });
        }); };
    },
    getUserForce: function (payload) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var result, e_3, errorType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, rcClient.methods.users.info(payload)];
                    case 1:
                        result = _a.sent();
                        dispatch(actions_1["default"].addUser(result.user));
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        errorType = lodash_1["default"].get(e_3, 'response.data.errorType');
                        // console.log('getUserForce', errorType, e)
                        if (errorType === 'error-invalid-user') {
                            if (payload.userId)
                                dispatch(actions_1["default"].addUserToIgnored(payload.userId));
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    },
    getUserLazy: function (payload) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var chat, userId, key;
            return __generator(this, function (_a) {
                chat = getState().chat;
                userId = payload.userId;
                key = userId ? lodash_1["default"].findKey(chat.users, { _id: userId }) : lodash_1["default"].findKey(chat.users, payload);
                if (storeHelpers_1["default"].shouldUpdate(chat.users[key || ''], storeHelpers_1["default"].TTL.TEN_HOURS))
                    return [2 /*return*/, dispatch(this.getUserForce(payload))];
                return [2 /*return*/];
            });
        }); };
    },
    getUnread: function (roomId) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var data, unread, room, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, rcClient.methods.im.counters({ roomId: roomId })];
                    case 1:
                        data = _a.sent();
                        unread = data.unreads;
                        if (lodash_1["default"].isNull(unread))
                            unread = data.msgs || 0;
                        room = getState().chat.rooms[roomId];
                        invariant_1["default"](room, 'getUnread room is not exists yet');
                        if (room.unread === unread)
                            return [2 /*return*/, null];
                        dispatch(actions_1["default"].setUnread({ roomId: roomId, unread: unread }));
                        return [3 /*break*/, 4];
                    case 2:
                        e_4 = _a.sent();
                        return [4 /*yield*/, dispatch(this.processRoomError(roomId))];
                    case 3:
                        _a.sent();
                        throw e_4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    },
    getGroupUnread: function (roomId) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var data, unread, room, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, rcClient.methods.groups.counters({ roomId: roomId })];
                    case 1:
                        data = _a.sent();
                        if (!data.joined)
                            return [2 /*return*/, null];
                        unread = data.unreads || 0;
                        room = getState().chat.rooms[roomId];
                        if (room.unread === unread)
                            return [2 /*return*/, null];
                        dispatch(actions_1["default"].setUnread({ roomId: roomId, unread: unread }));
                        return [3 /*break*/, 4];
                    case 2:
                        e_5 = _a.sent();
                        return [4 /*yield*/, dispatch(this.processRoomError(e_5))];
                    case 3:
                        _a.sent();
                        throw e_5;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    },
    getGroupMessages: function (roomId, options) {
        var _this = this;
        var isReplace = (options || {}).isReplace;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var messages, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, rcClient.methods.groups.history({ roomId: roomId })];
                    case 1:
                        messages = (_a.sent()).messages;
                        dispatch(actions_1["default"].setMessages(roomId, messages || [], isReplace));
                        return [2 /*return*/, messages];
                    case 2:
                        e_6 = _a.sent();
                        dispatch(this.processRoomError(roomId, e_6));
                        throw e_6;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    },
    getDirectMessages: function (roomId, options) {
        var _this = this;
        var isReplace = (options || {}).isReplace;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var _a, messages, e_7;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, rcClient.methods.im.history({ roomId: roomId })];
                    case 1:
                        _a = (_b.sent()).messages, messages = _a === void 0 ? [] : _a;
                        dispatch(actions_1["default"].setMessages(roomId, messages, isReplace));
                        return [3 /*break*/, 3];
                    case 2:
                        e_7 = _b.sent();
                        dispatch(this.processRoomError(roomId, e_7));
                        throw e_7;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    },
    getMessagesEarlier: function (roomId) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var rooms, room, oldestMessage, params, _a, messages, _b, messages;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        rooms = getState().chat.rooms;
                        room = rooms[roomId];
                        if (!room)
                            return [2 /*return*/, null];
                        oldestMessage = (_c = room.messages) === null || _c === void 0 ? void 0 : _c[0];
                        if (!oldestMessage)
                            return [2 /*return*/, null];
                        params = { roomId: roomId, latest: oldestMessage.ts };
                        if (!room.isDirect) return [3 /*break*/, 2];
                        return [4 /*yield*/, rcClient.methods.im.history(params)];
                    case 1:
                        _a = (_d.sent()).messages, messages = _a === void 0 ? [] : _a;
                        dispatch(actions_1["default"].setMessages(roomId, messages));
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, rcClient.methods.groups.history(params)];
                    case 3:
                        _b = (_d.sent()).messages, messages = _b === void 0 ? [] : _b;
                        dispatch(actions_1["default"].setMessages(roomId, messages));
                        _d.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    },
    getMessagesNewest: function (roomId) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var rooms, room, existingMessages, newestMessage, params, _a, messages, _b, messages;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        rooms = getState().chat.rooms;
                        room = rooms[roomId];
                        if (!room)
                            return [2 /*return*/, null];
                        existingMessages = room.messages || [];
                        newestMessage = existingMessages[existingMessages.length - 1];
                        if (!newestMessage)
                            return [2 /*return*/, null];
                        params = { roomId: roomId, oldest: newestMessage.ts };
                        if (!room.isDirect) return [3 /*break*/, 2];
                        return [4 /*yield*/, rcClient.methods.im.history(params)];
                    case 1:
                        _a = (_c.sent()).messages, messages = _a === void 0 ? [] : _a;
                        dispatch(actions_1["default"].setMessages(roomId, messages));
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, rcClient.methods.groups.history(params)];
                    case 3:
                        _b = (_c.sent()).messages, messages = _b === void 0 ? [] : _b;
                        dispatch(actions_1["default"].setMessages(roomId, messages));
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    },
    sendDirectMessage: function (roomId, text, asset) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var chat, room;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        chat = getState().chat;
                        if (roomId.length === 17) {
                            // when userId is sent
                            roomId = [roomId, ((_a = chat.me) === null || _a === void 0 ? void 0 : _a._id) || ''].sort().join('');
                        }
                        room = chat.rooms[roomId];
                        if (!lodash_1["default"].isEmpty(room)) return [3 /*break*/, 2];
                        // ensure room exists
                        return [4 /*yield*/, dispatch(this.getDirectChat(roomId.replace(((_b = chat.me) === null || _b === void 0 ? void 0 : _b._id) || '', '')))];
                    case 1:
                        // ensure room exists
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        if (!(room === null || room === void 0 ? void 0 : room.isMock)) return [3 /*break*/, 4];
                        // ensure room exists
                        return [4 /*yield*/, dispatch(this.getDirectChat(room.userId))];
                    case 3:
                        // ensure room exists
                        _c.sent();
                        _c.label = 4;
                    case 4: return [4 /*yield*/, dispatch(this.sendMessage(roomId, text, asset))];
                    case 5:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    },
    sendMessage: function (roomId, text, attachment) {
        var _this = this;
        text = text.trim();
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                dispatch(actions_1["default"].addMessageToQueue({ roomId: roomId, text: text, attachment: attachment }));
                return [2 /*return*/];
            });
        }); };
    },
    sendQueuedMessage: function (roomId, payload) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, rcClient.methods.chat.postMessage(payload)];
                    case 1:
                        message = (_a.sent()).message;
                        dispatch(actions_1["default"].setMessages(roomId, [message]));
                        return [2 /*return*/];
                }
            });
        }); };
    },
    getDirectChat: function (userId) {
        var _this = this;
        return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
            var users, user, room;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(this.getUser({ userId: userId }, { isForce: false }))];
                    case 1:
                        _a.sent();
                        users = getState().chat.users;
                        user = users[userId];
                        if (!user) {
                            console.warn(new Error('No User for getDirectChat'));
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, rcClient.methods.im.create({
                                username: user.username
                            })];
                    case 2:
                        room = (_a.sent()).room;
                        dispatch(actions_1["default"].addRoom(room));
                        return [2 /*return*/, room._id];
                }
            });
        }); };
    },
    readMessages: function (roomId) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch(actions_1["default"].setUnread({ roomId: roomId, unread: 0 })); // stop blinking counter
                        return [4 /*yield*/, rcClient.methods.subscriptions.read({ rid: roomId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    },
    processRoomError: function (roomId, err) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var _a, data, status, errorType;
            return __generator(this, function (_b) {
                _a = err.response || {}, data = _a.data, status = _a.status;
                errorType = (data || {}).errorType;
                if (errorType === 'error-room-not-found') {
                    dispatch(actions_1["default"].deleteRoom(roomId));
                }
                return [2 /*return*/];
            });
        }); };
    }
};
